"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectIsDashboardLoading = exports.selectDashboardLoading = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var selectSelf = toolkit_1.createSelector(function (state) { return state; }, function (state) { return state.loading; });
/**
 * @internal
 */
exports.selectDashboardLoading = selectSelf;
/**
 * @internal
 */
exports.selectIsDashboardLoading = toolkit_1.createSelector(selectSelf, function (state) { return state.loading; });
//# sourceMappingURL=loadingSelectors.js.map